type LineProps = {
	color?: string;
	height?: number;
	className?: string;
};

export default function Line({
	color = "#f0f0f0",
	height = 1,
	className,
	...args
}: LineProps) {
	return (
		<hr
			style={{ backgroundColor: color, height, border: "none" }}
			className={className}
			{...args}
		/>
	);
}
